module.exports = __webpack_public_path__ + "static/media/example1.2d62678a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Jiggle/Impact/img/example1.mp4
// module id = 298
// module chunks = 0